module.exports = __webpack_public_path__ + "r-v3/img/zoom_ori_white.da962646.svg";